import React, { useEffect, useState } from "react";
import {
  Users,
  Calendar,
  DollarSign,
  Shield,
  BarChart3,
  Clock,
  Lock,
  Unlock,
  Car,
  Camera,
  Building2,
  CreditCard,
  ArrowRight,
  CheckCircle,
  Star,
  Globe,
  Zap,
} from "lucide-react";
import { Modal } from "antd";
import Login from "../user/Login";
import appleStoreImage from "../../assets/appleStore.png";
import playStoreImage from "../../assets/playStore.webp";

const WelcomePage = () => {
  // const [isLogged, setIsLogged] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [unlockedFeatures, setUnlockedFeatures] = useState(new Set());
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const [showLoginModal, setShowLoginModal] = useState(false);

  // useEffect(()=>{

  // },[])
  const handleLoginSuccess = () => {
    // setIsLogged(true);
    setShowLoginModal(false);
  };

  const handlePlayStoreClick = () => {
    window.open("https://play.google.com/store/apps/details?id=com.softomation.hrms_project", "_blank");
  };

  const handleAppleStoreClick = () => {
    window.open("https://apps.apple.com/app/hrms360/id6751835203", "_blank");
  };

  const hrmsFeatures = [
    {
      id: "payroll",
      title: "Payroll Management",
      description:
        "Automated salary processing, tax calculations, and payslip generation",
      icon: DollarSign,
      color: "bg-gradient-to-r from-emerald-500 to-teal-600",
      locked: false,
    },
    {
      id: "attendance",
      title: "Attendance Tracking",
      description: "Real-time attendance monitoring with biometric integration",
      icon: Clock,
      color: "bg-gradient-to-r from-blue-500 to-indigo-600",
      locked: false,
    },
    {
      id: "leave",
      title: "Leave Management",
      description:
        "Streamlined leave requests, approvals, and holiday management",
      icon: Calendar,
      color: "bg-gradient-to-r from-purple-500 to-pink-600",
      locked: true,
    },
    {
      id: "employee",
      title: "Employee Management",
      description: "Complete employee lifecycle management and records",
      icon: Users,
      color: "bg-gradient-to-r from-orange-500 to-red-600",
      locked: false,
    },
    {
      id: "analytics",
      title: "HR Analytics",
      description: "Advanced reporting and workforce analytics dashboard",
      icon: BarChart3,
      color: "bg-gradient-to-r from-cyan-500 to-blue-600",
      locked: true,
    },
    {
      id: "security",
      title: "Role-Based Access",
      description: "Secure user management with granular permissions",
      icon: Shield,
      color: "bg-gradient-to-r from-violet-500 to-purple-600",
      locked: false,
    },
  ];

  const otherProjects = [
    {
      title: "Enterprise ERP",
      description:
        "Complete business management solution with integrated modules",
      icon: Building2,
      color: "from-blue-600 to-purple-700",
      features: [
        "Inventory Management",
        "Financial Accounting",
        "Supply Chain",
      ],
      status: "Featured",
    },
    {
      title: "Smart Parking System",
      description: "IoT-enabled parking management with real-time monitoring",
      icon: Car,
      color: "from-green-600 to-teal-700",
      features: ["Real-time Monitoring", "Mobile App", "Payment Integration"],
      status: "New",
    },
    {
      title: "ANPR System",
      description:
        "Automatic Number Plate Recognition for security and traffic",
      icon: Camera,
      color: "from-red-600 to-pink-700",
      features: ["AI Recognition", "Database Integration", "Real-time Alerts"],
      status: "Popular",
    },
    {
      title: "Loan Management",
      description: "Comprehensive loan processing and management platform",
      icon: CreditCard,
      color: "from-yellow-600 to-orange-700",
      features: [
        "Application Processing",
        "Risk Assessment",
        "Payment Tracking",
      ],
      status: "Enterprise",
    },
  ];

  const toggleFeature = (featureId) => {
    const newUnlocked = new Set(unlockedFeatures);
    if (newUnlocked.has(featureId)) {
      newUnlocked.delete(featureId);
    } else {
      newUnlocked.add(featureId);
    }
    setUnlockedFeatures(newUnlocked);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="relative bg-gradient-to-r from-slate-900 via-purple-900 to-slate-900">
        <div className="absolute inset-0 bg-black/20"></div>
        <nav className="relative container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center">
                <Building2 size={20} className="text-white" />
              </div>
              <span className="text-2xl font-bold text-white">
                HRM <span className="text-blue-400">360</span>
              </span>
            </div>

            {/* <div className="flex items-center space-x-6">
              {!isLogged ? (
                <div className="flex items-center space-x-6">
                  <a
                    href="/admin/auth/login"
                    className="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium px-6 py-2 rounded-md hover:from-blue-700 hover:to-purple-700 transition-all"
                  >
                    Login
                  </a>
                  <a
                    href="/auth/registerClient"
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    Sign Up
                  </a>
                </div>
              ) : (
                <div className="flex items-center space-x-6">
                  <a
                    href="/admin/dashboard"
                    className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white font-medium px-6 py-2 rounded-md hover:from-teal-700 hover:to-cyan-700 transition-all"
                  >
                    Dashboard
                  </a>

                  <a
                    href="/admin/auth/logout"
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    Logout
                  </a>
                </div>
              )}
            </div> */}
            {!isLogged ? (
              <div className="flex items-center space-x-10">
                <div className="flex items-center space-x-5">
                  <img
                    src={playStoreImage}
                    alt="Play Store"
                    onClick={handlePlayStoreClick}
                    style={{
                      height: "32px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      transition: "transform 0.2s ease-in-out"
                    }}
                    onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                  />
                  <img
                    src={appleStoreImage}
                    alt="Apple Store"
                    onClick={handleAppleStoreClick}
                    style={{
                      height: "32px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      transition: "transform 0.2s ease-in-out"
                    }}
                    onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                  />
                </div>
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => setShowLoginModal(true)}
                    className="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium px-6 py-2 rounded-md hover:from-blue-700 hover:to-purple-700 transition-all"
                  >
                    Login
                  </button>
                  <a
                    href="/auth/registerClient"
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    Sign Up
                  </a>
                </div>
              </div>
            ) : (
              <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-3">
                  <img
                    src={playStoreImage}
                    alt="Play Store"
                    onClick={handlePlayStoreClick}
                    style={{
                      height: "32px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      transition: "transform 0.2s ease-in-out"
                    }}
                    onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                  />
                  <img
                    src={appleStoreImage}
                    alt="Apple Store"
                    onClick={handleAppleStoreClick}
                    style={{
                      height: "32px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      transition: "transform 0.2s ease-in-out"
                    }}
                    onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                  />
                </div>
                <a
                  href="/admin/dashboard"
                  className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white font-medium px-6 py-2 rounded-md hover:from-teal-700 hover:to-cyan-700 transition-all"
                >
                  Dashboard
                </a>
                <a
                  href="/admin/auth/logout"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Logout
                </a>
              </div>
            )}
          </div>
        </nav>
        <Modal
          title=""
          open={showLoginModal}
          onCancel={() => setShowLoginModal(false)}
          footer={null}
          centered
          style={{ backgroundColor: "#ffffff" }}
        >
          <Login
            onLoginSuccess={handleLoginSuccess}
            onCancel={() => setShowLoginModal(false)}
          />
        </Modal>
        <div className="relative container mx-auto px-12 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Title, Description, and Cards */}
            <div className="text-center lg:text-left">
              <h1
                className="text-white mb-6 leading-tight font-bold"
                style={{ fontSize: "clamp(2.5rem, 5vw, 4rem)" }}
              >
                Revolutionize Your
                <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-500 bg-clip-text text-transparent animate-pulse">
                  {" "}
                  Workforce Experience
                </span>
              </h1>

              <p className="text-xl text-gray-300 mb-8 max-w-3xl">
                Welcome to a smarter way to manage your people. Our intelligent
                HRMS platform offers:
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {[
                  {
                    icon: "🚀",
                    title: "Automation-first",
                    description: "Streamline HR tasks",
                  },
                  {
                    icon: "📊",
                    title: "Analytics",
                    description: "Smart decisions",
                  },
                  {
                    icon: "🎯",
                    title: "Personalized UX",
                    description: "Employee satisfaction",
                  },
                  {
                    icon: "🔍",
                    title: "Live Insights",
                    description: "Track performance",
                  },
                  {
                    icon: "🤝",
                    title: "Empower Teams",
                    description: "Collaborate & grow",
                  },
                  {
                    icon: "🧠",
                    title: "AI Predictions",
                    description: "Proactive planning",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-white/10 backdrop-blur-md border border-white/20 text-white p-4 rounded-lg shadow-md hover:shadow-lg transition duration-300"
                  >
                    <div className="text-xl mb-2">{item.icon}</div>
                    <h3 className="text-md font-semibold mb-1">{item.title}</h3>
                    <p className="text-sm text-gray-300">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="text-center">
              <img
                src="https://i.ibb.co/cNfg9Y7/MOKEUPHRMOS.png"
                alt="HRM 360 Dashboard Mockup"
                className="w-full max-w-lg mx-auto rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </header>

      {/* HRMS Features Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-gray-900 mb-4 text-3xl font-bold">
              Powerful HRMS Features
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Unlock the full potential of your HR operations with our
              comprehensive suite of tools
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {hrmsFeatures.map((feature) => {
              const Icon = feature.icon;
              const isLocked =
                feature.locked && !unlockedFeatures.has(feature.id);
              const isHovered = hoveredCard === feature.id;

              return (
                <div
                  key={feature.id}
                  className={`bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ${
                    isHovered ? "transform scale-105 -translate-y-2" : ""
                  } ${isLocked ? "opacity-75" : ""}`}
                  onMouseEnter={() => setHoveredCard(feature.id)}
                  onMouseLeave={() => setHoveredCard(null)}
                  onClick={() => feature.locked && toggleFeature(feature.id)}
                >
                  {/* Card Header */}
                  <div className={`${feature.color} p-6 relative rounded-t-lg`}>
                    <div className="flex items-center justify-between">
                      <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                        <Icon size={24} className="text-white" />
                      </div>

                      {feature.locked && (
                        <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                          {isLocked ? <Lock size={16} /> : <Unlock size={16} />}
                        </div>
                      )}
                    </div>

                    {/* Unlock Animation */}
                    {feature.locked && unlockedFeatures.has(feature.id) && (
                      <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 flex items-center justify-center rounded-t-lg">
                        <div className="w-8 h-8 rounded-full bg-transparent animate-pulse flex items-center justify-center">
                          <CheckCircle size={24} className="text-white" />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Card Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>

                    {isLocked && (
                      <div className="mt-4 flex items-center">
                        <Lock size={16} className="mr-2 text-gray-500" />
                        <span className="text-gray-500">
                          Click to unlock this feature
                        </span>
                      </div>
                    )}

                    {!isLocked && (
                      <div className="mt-4 flex items-center text-blue-600 font-medium group">
                        <span>Learn more</span>
                        <ArrowRight
                          size={16}
                          className="ml-2 transform group-hover:translate-x-1 transition-transform"
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Other Projects Portfolio */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center bg-gradient-to-r from-blue-100 to-purple-100 rounded-full px-6 py-2 mb-4">
              <Globe size={16} className="text-blue-600 mr-2" />
              <span className="text-blue-600 font-medium">
                Our Solutions Portfolio
              </span>
            </div>
            <h2 className="text-gray-900 mb-4 text-3xl font-bold">
              Enterprise Solutions Beyond HR
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover our comprehensive suite of business solutions designed to
              streamline operations across industries
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {otherProjects.map((project, index) => {
              const Icon = project.icon;

              return (
                <div
                  key={index}
                  className="relative bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 group"
                >
                  {/* Status Badge */}
                  <span
                    className={`absolute top-4 right-4 px-2 py-1 rounded text-white text-sm font-medium ${
                      project.status === "Featured"
                        ? "bg-blue-500"
                        : project.status === "New"
                        ? "bg-green-500"
                        : project.status === "Popular"
                        ? "bg-red-500"
                        : "bg-yellow-500"
                    }`}
                  >
                    {project.status}
                  </span>

                  {/* Project Icon */}
                  <div
                    className={`w-16 h-16 rounded-full bg-gradient-to-r ${project.color} mb-6 group-hover:scale-110 transition-transform duration-300 flex items-center justify-center`}
                  >
                    <Icon size={32} className="text-white" />
                  </div>

                  {/* Project Info */}
                  <h3 className="text-xl font-semibold text-gray-900 mb-3 px-8">
                    {project.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed px-8">
                    {project.description}
                  </p>

                  {/* Features List */}
                  <div className="space-y-2 mb-8 px-8">
                    {project.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center">
                        <Zap
                          size={16}
                          className="text-blue-500 mr-2 flex-shrink-0"
                        />
                        <span className="text-gray-600">{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA Button */}
                  <button
                    className={`w-full bg-gradient-to-r ${project.color} text-white font-medium py-3 rounded-b-lg hover:opacity-90 transition-all mx-0`}
                  >
                    Explore Solution
                    <ArrowRight size={16} className="inline ml-2" />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container mx-auto px-6 relative">
          <div className="max-w-4xl mx-auto text-center">
            <h2
              className="text-white mb-6 font-bold"
              style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}
            >
              Ready to Transform Your Business?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Join thousands of companies that trust our solutions to streamline
              their operations and drive growth.
            </p>
            <div className="flex justify-center space-x-4 flex-wrap gap-4">
              <button className="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium px-8 py-3 rounded-md hover:from-blue-700 hover:to-purple-700 transition-all">
                Get Started Today
              </button>
              <button className="border-2 border-white/30 text-white bg-transparent hover:bg-white/10 px-8 py-3 rounded-md transition-all">
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <Building2 size={32} className="text-blue-400" />
                <span className="text-xl font-bold text-white">
                  Softomation
                </span>
              </div>
              <p className="text-gray-400">
                Transforming businesses with innovative technology solutions.
              </p>
            </div>

            <div>
              <h3 className="text-white mb-4 font-semibold">Solutions</h3>
              <div className="flex flex-col space-y-2">
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  HRMS
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  ERP System
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Parking Management
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  ANPR System
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-white mb-4 font-semibold">Company</h3>
              <div className="flex flex-col space-y-2">
                <a
                  href="https://softomation.com/about/"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  About Us
                </a>
                <a
                  href="https://softomation.com/contact/"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact
                </a>
                <a
                  href="https://softomation.com/product/"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Product
                </a>
                <a
                  href="https://softomation.com/services/"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Service
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-white mb-4 font-semibold">Connect</h3>
              <div className="flex space-x-4">
                <div className="w-10 h-10 rounded-full bg-gray-800 hover:bg-blue-600 transition-colors cursor-pointer flex items-center justify-center">
                  <Globe size={20} />
                </div>
                <div className="w-10 h-10 rounded-full bg-gray-800 hover:bg-blue-600 transition-colors cursor-pointer flex items-center justify-center">
                  <Building2 size={20} />
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <span className="text-gray-400">
              © 2025 Softomation Technologies. All rights reserved.
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default WelcomePage;

// import dayjs from "dayjs";
// import React from "react";
// import { Link } from "react-router-dom";

// const WelcomePage = () => {
// 	const isLogged = Boolean(localStorage.getItem("isLogged"));

// 	return (
// 		<div>
// 			<section className='w-full px-8 text-gray-700 bg-white'>
// 				<div className='container flex flex-col flex-wrap items-center justify-between py-5 mx-auto md:flex-row max-w-7xl'>
// 					<div className='relative flex flex-col md:flex-row'>
// 						<a
// 							href='#_'
// 							className='flex items-center mb-5 font-medium text-gray-900 lg:w-auto lg:items-center lg:justify-center md:mb-0'>
// 							<span className='mx-auto text-xl font-black leading-none text-gray-900 select-none'>
// 								HRM <span className='text-blue-600'>360</span>
// 								<span className='text-teal-600'></span>
// 							</span>
// 						</a>
// 					</div>

// 					<div className='inline-flex items-center ml-5 space-x-6 lg:justify-end'>
// 						<Link
// 							to='/auth/registerClient'
// 							className='text-base font-medium leading-6 text-gray-600 whitespace-no-wrap transition duration-150 ease-in-out hover:text-gray-900'>
// 							Sign Up
// 						</Link>
// 						{!isLogged ? (
// 							<Link
// 								to='/admin/auth/login'
// 								className='inline-flex items-center justify-center px-4 py-2 text-base font-medium leading-6 text-white whitespace-no-wrap bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600'>
// 								Login
// 							</Link>
// 						) : (
// 							<Link
// 								to='/admin/dashboard'
// 								className='inline-flex items-center justify-center px-4 py-2 text-base font-medium leading-6 text-white whitespace-no-wrap bg-teal-600 border border-transparent rounded-md shadow-sm hover:bg-teal-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-600'>
// 								Dashboard
// 							</Link>
// 						)}
// 					</div>
// 				</div>
// 			</section>

// 			<section className='px-2 py-32 bg-white md:px-0'>
// 				<div className='container items-center max-w-6xl px-8 mx-auto xl:px-5'>
// 					<div className='flex flex-wrap items-center sm:-mx-3'>
// 						<div className='w-full md:w-1/2 md:px-3'>
// 							<div className='w-full pb-6 space-y-6 sm:max-w-md lg:max-w-lg md:space-y-4 lg:space-y-8 xl:space-y-9 sm:pr-5 lg:pr-0 md:pb-0'>
// 								<h1 className='text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-4xl lg:text-5xl xl:text-6xl'>
// 									<span className='block xl:inline'>
// 										Revolutionize & Simplify.
// 									</span>
// 									<span className='block text-blue-600 xl:inline'>
// 										Your HR Solutions.
// 									</span>
// 								</h1>
// 								<p className='mx-auto text-base text-gray-500 sm:max-w-md lg:text-xl md:max-w-3xl'>
// 									Embrace digital transformation with our powerful HR tool. Stay
// 									ahead of the curve and gain a competitive edge.
// 								</p>

// 							</div>
// 						</div>
// 						<div className='w-full md:w-1/2'>
// 							<div className='w-full h-auto overflow-hidden rounded-md shadow-xl sm:rounded-xl'>
// 								<img
// 									src='https://i.ibb.co/cNfg9Y7/MOKEUPHRMOS.png" alt="MOKEUPHRMOS'
// 									alt='HRM-360 best HRM '
// 								/>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</section>

// 			<section className='w-full bg-white pt-7 pb-7 md:pt-20 md:pb-24'>
// 				<div className='box-border flex flex-col items-center content-center px-8 mx-auto leading-6 text-black border-0 border-gray-300 border-solid md:flex-row max-w-7xl lg:px-16'>
// 					<div className='box-border relative w-full max-w-md px-4 mt-5 mb-4 -ml-5 text-center bg-no-repeat bg-contain border-solid md:ml-0 md:mt-0 md:max-w-none lg:mb-0 md:w-1/2 xl:pl-10'>
// 						<img
// 							src='https://i.ibb.co/k8VmY84/Humaaans-3-Characters.png'
// 							className='p-2 pl-6 pr-5 xl:pl-16 xl:pr-20 '
// 							alt='team'
// 						/>
// 					</div>

// 					<div className='box-border order-first w-full text-black border-solid md:w-1/2 md:pl-10 md:order-none'>
// 						<h2 className='m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl'>
// 							Embrace digital transformation
// 						</h2>
// 						<p className='pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-12 xl:pr-32 lg:text-lg'>
// 							Stay ahead of the curve and gain a competitive edge with our
// 							innovative HR technologies.
// 						</p>
// 						<ul className='p-0 m-0 leading-6 border-0 border-gray-300'>
// 							<li className='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
// 								<span className='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-indigo-500 rounded-full'>
// 									<span className='text-sm font-bold'>✓</span>
// 								</span>{" "}
// 								Optimize Your HR Performance
// 							</li>
// 							<li className='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
// 								<span className='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-indigo-500 rounded-full'>
// 									<span className='text-sm font-bold'>✓</span>
// 								</span>{" "}
// 								Simplify Your HR Processes
// 							</li>
// 							<li className='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
// 								<span className='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-indigo-500 rounded-full'>
// 									<span className='text-sm font-bold'>✓</span>
// 								</span>{" "}
// 								Empower Your HR Operations
// 							</li>
// 						</ul>
// 					</div>
// 				</div>
// 				<div className='box-border flex flex-col items-center content-center px-8 mx-auto mt-2 leading-6 text-black border-0 border-gray-300 border-solid md:mt-20 xl:mt-0 md:flex-row max-w-7xl lg:px-16'>
// 					<div className='box-border w-full text-black border-solid md:w-1/2 md:pl-6 xl:pl-32'>
// 						<h2 className='m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl'>
// 							Automated Systems
// 						</h2>
// 						<p className='pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-10 lg:text-lg'>
// 							Get More Done in Less Time with Our Intuitive, Automated System
// 						</p>
// 						<ul className='p-0 m-0 leading-6 border-0 border-gray-300'>
// 							<li className='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
// 								<span className='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-indigo-500 rounded-full'>
// 									<span className='text-sm font-bold'>✓</span>
// 								</span>{" "}
// 								Automated Payroll Processing and Payslip Generation.
// 							</li>
// 							<li className='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
// 								<span className='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-indigo-500 rounded-full'>
// 									<span className='text-sm font-bold'>✓</span>
// 								</span>{" "}
// 								Holiday Management and Leave Management.
// 							</li>
// 							<li className='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
// 								<span className='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-indigo-500 rounded-full'>
// 									<span className='text-sm font-bold'>✓</span>
// 								</span>{" "}
// 								Automated Attendance Management and Time Tracking.
// 							</li>
// 						</ul>
// 					</div>

// 					<div className='box-border relative w-full max-w-md px-4 mt-10 mb-4 text-center bg-no-repeat bg-contain border-solid md:mt-0 md:max-w-none lg:mb-0 md:w-1/2'>
// 						<img
// 							src='https://i.ibb.co/7CHnkNS/undraw-Chat-bot-re-e2gj.png'
// 							className='pl-4 sm:pr-10 xl:pl-10 lg:pr-32'
// 							alt='ai'
// 						/>
// 					</div>
// 				</div>
// 			</section>

// 			<section className='py-20 bg-gray-50'>
// 				<div className='container items-center max-w-6xl px-4 px-10 mx-auto sm:px-20 md:px-32 lg:px-16'>
// 					<div className='flex flex-wrap items-center -mx-3'>
// 						<div className='order-1 w-full px-3 lg:w-1/2 lg:order-0'>
// 							<div className='w-full lg:max-w-md'>
// 								<h2 className='mb-4 text-3xl font-bold leading-tight tracking-tight sm:text-4xl font-heading'>
// 									Reduce Your Workload and Improve Your Efficiency
// 								</h2>
// 								<p className='mb-4 font-medium tracking-tight text-gray-400 xl:mb-6'>
// 									User-Friendly HR Solutions for All Your Needs, Designed to
// 									Make Your Life Easier
// 								</p>
// 								<ul>
// 									<li className='flex items-center py-2 space-x-4 xl:py-3'>
// 										<svg
// 											className='w-8 h-8 text-pink-500'
// 											fill='none'
// 											stroke='currentColor'
// 											viewBox='0 0 24 24'
// 											xmlns='http://www.w3.org/2000/svg'>
// 											<path
// 												stroke-linecap='round'
// 												stroke-linejoin='round'
// 												stroke-width='2'
// 												d='M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z'></path>
// 										</svg>
// 										<span className='font-medium text-gray-500'>
// 											Intrigrated Accounting System with Payroll Management
// 										</span>
// 									</li>
// 									<li className='flex items-center py-2 space-x-4 xl:py-3'>
// 										<svg
// 											className='w-8 h-8 text-indigo-500'
// 											fill='none'
// 											stroke='currentColor'
// 											viewBox='0 0 24 24'
// 											xmlns='http://www.w3.org/2000/svg'>
// 											<path
// 												stroke-linecap='round'
// 												stroke-linejoin='round'
// 												stroke-width='2'
// 												d='M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'></path>
// 										</svg>
// 										<span className='font-medium text-gray-500'>
// 											Automated Leave Management and Holiday Management.
// 										</span>
// 									</li>
// 									<li className='flex items-center py-2 space-x-4 xl:py-3'>
// 										<svg
// 											className='w-8 h-8 text-green-500'
// 											fill='none'
// 											stroke='currentColor'
// 											viewBox='0 0 24 24'
// 											xmlns='http://www.w3.org/2000/svg'>
// 											<path
// 												stroke-linecap='round'
// 												stroke-linejoin='round'
// 												stroke-width='2'
// 												d='M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'></path>
// 										</svg>
// 										<span className='font-medium text-gray-500'>
// 											Role Based Access Control and User Management.
// 										</span>
// 									</li>
// 								</ul>
// 							</div>
// 						</div>
// 						<div className='w-full px-3 mb-12 lg:w-1/2 order-0 lg:order-1 lg:mb-0'>
// 							<img
// 								className='mx-auto sm:max-w-sm lg:max-w-full'
// 								src='https://i.ibb.co/7Rkm1T8/undraw-Join-re-w1lh.png'
// 								alt='feature'
// 							/>
// 						</div>
// 					</div>
// 				</div>
// 			</section>

// 			<section className='bg-white'>
// 				<div className='max-w-screen-xl px-4 py-12 mx-auto space-y-8 overflow-hidden sm:px-6 lg:px-8'>
// 					<nav className='flex flex-wrap justify-center -mx-5 -my-2'>
// 						<div className='px-5 py-2'>
// 							<a
// 								href='https://softomation.com/about-us/'
// 								className='text-base leading-6 text-gray-500 hover:text-gray-900'>
// 								About
// 							</a>
// 						</div>
// 						<div className='px-5 py-2'>
// 							<a
// 								href='https://softomation.com/blog/'
// 								className='text-base leading-6 text-gray-500 hover:text-gray-900'>
// 								Blog
// 							</a>
// 						</div>
// 						<div className='px-5 py-2'>
// 							<a
// 								href='https://softomation.com/about-us/'
// 								className='text-base leading-6 text-gray-500 hover:text-gray-900'>
// 								Team
// 							</a>
// 						</div>
// 						<div className='px-5 py-2'>
// 							<a
// 								href='https://softomation.com/portfolio'
// 								className='text-base leading-6 text-gray-500 hover:text-gray-900'>
// 								Products
// 							</a>
// 						</div>
// 						<div className='px-5 py-2'>
// 							<a
// 								href='https://softomation.com/contact-us/'
// 								className='text-base leading-6 text-gray-500 hover:text-gray-900'>
// 								Contact
// 							</a>
// 						</div>
// 					</nav>
// 					<div className='flex justify-center mt-8 space-x-6'>
// 						<a
// 							href='https://www.facebook.com/softomationtechnologies'
// 							className='text-gray-400 hover:text-gray-500'>
// 							<span className='sr-only'>Facebook</span>
// 							<svg
// 								className='w-6 h-6'
// 								aria-hidden='true'
// 								fill='currentColor'
// 								viewBox='0 0 24 24'>
// 								<path
// 									fill-rule='evenodd'
// 									d='M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z'
// 									clip-rule='evenodd'></path>
// 							</svg>
// 						</a>
// 						<a
// 							href='https://www.instagram.com/softomationtechnologies/'
// 							className='text-gray-400 hover:text-gray-500'>
// 							<span className='sr-only'>Instagram</span>
// 							<svg
// 								className='w-6 h-6'
// 								aria-hidden='true'
// 								fill='currentColor'
// 								viewBox='0 0 24 24'>
// 								<path
// 									fill-rule='evenodd'
// 									d='M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z'
// 									clip-rule='evenodd'></path>
// 							</svg>
// 						</a>
// 						<a
// 							href='https://www.linkedin.com/company/softomationtechnologies'
// 							className='text-gray-400 hover:text-gray-500'>
// 							<span className='sr-only'>LinkedIn</span>
// 							<svg
// 								className='w-6 h-6'
// 								aria-hidden='true'
// 								fill='currentColor'
// 								version='1.1'
// 								id='Layer_1'
// 								xmlns='http://www.w3.org/2000/svg'
// 								viewBox='-143 145 512 512'>
// 								<g id='SVGRepo_bgCarrier' stroke-width='0'></g>
// 								<g
// 									id='SVGRepo_tracerCarrier'
// 									stroke-linecap='round'
// 									stroke-linejoin='round'></g>
// 								<g id='SVGRepo_iconCarrier'>
// 									{" "}
// 									<path d='M113,145c-141.4,0-256,114.6-256,256s114.6,256,256,256s256-114.6,256-256S254.4,145,113,145z M41.4,508.1H-8.5V348.4h49.9 V508.1z M15.1,328.4h-0.4c-18.1,0-29.8-12.2-29.8-27.7c0-15.8,12.1-27.7,30.5-27.7c18.4,0,29.7,11.9,30.1,27.7 C45.6,316.1,33.9,328.4,15.1,328.4z M241,508.1h-56.6v-82.6c0-21.6-8.8-36.4-28.3-36.4c-14.9,0-23.2,10-27,19.6 c-1.4,3.4-1.2,8.2-1.2,13.1v86.3H71.8c0,0,0.7-146.4,0-159.7h56.1v25.1c3.3-11,21.2-26.6,49.8-26.6c35.5,0,63.3,23,63.3,72.4V508.1z '></path>{" "}
// 								</g>
// 							</svg>
// 						</a>
// 						<a
// 							href='https://github.com/softomationtechnologies'
// 							className='text-gray-400 hover:text-gray-500'>
// 							<span className='sr-only'>GitHub</span>
// 							<svg
// 								className='w-6 h-6'
// 								aria-hidden='true'
// 								fill='currentColor'
// 								viewBox='0 0 24 24'>
// 								<path
// 									fill-rule='evenodd'
// 									d='M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z'
// 									clip-rule='evenodd'></path>
// 							</svg>
// 						</a>
// 					</div>
// 					<p className='mt-8 text-base leading-6 text-center text-gray-400'>
// 						{`© ${dayjs().year()} Softomation Technologies . All rights reserved.`}
// 					</p>
// 				</div>
// 			</section>
// 		</div>
// 	);
// };

// export default WelcomePage;
